export default __webpack_public_path__ + "static/media/MATHEMATICS_STATISTICS_AND_PROBABILITY.8027271d.svg";